import React, { useState, Fragment } from "react";
import { Drawer, Button, Tabs } from "antd";
import {
  StateSIM,
  StateGPSF,
  StatesDNSF,
  StateConnectionF,
  IdentityTableF,
} from "Components/Topology/Device/DeviceTableF_StateModalF";
import { useDeviceIdentityByID, useDeviceStatusByID } from "Components/Dashboard/queries";

const options = ["Identity", "SIM", "GPS", "DNS", "Connection"];
const { TabPane } = Tabs;

const DeviceStatusIdentiy = ({ id }: { id: string }) => {
  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState<string | number>("Identity");

  const { data: deviceIdentityByID, isFetching: deviceIdentityFetching } = useDeviceIdentityByID(id, Boolean(id));

  const { data: deviceStatusByID, isFetching: deviceStatusFetching } = useDeviceStatusByID(id, Boolean(id));

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  //   const getComponent = (value: string | number) => {
  //     switch (value) {
  //       case "SIM":
  //         return deviceStatusByID && <StateSIM deviceStatusByID={deviceStatusByID} />;
  //       case "GPS":
  //         return deviceStatusByID && <StateGPSF deviceStatusByID={deviceStatusByID} />;
  //       case "DNS":
  //         return deviceStatusByID && <StatesDNSF deviceStatusByID={deviceStatusByID} />;
  //       case "Connection":
  //         return deviceStatusByID && <StateConnectionF deviceStatusByID={deviceStatusByID} />;
  //       case "Identity":
  //         return (
  //           deviceStatusByID &&
  //           deviceIdentityByID && (
  //             <IdentityTableF deviceStatusByID={deviceStatusByID} deviceIdentityByID={deviceIdentityByID} />
  //           )
  //         );
  //     }
  //   };

  return (
    <>
      <Button type="primary" onClick={showDrawer}>
        Detail
      </Button>
      <Drawer title="Device Detail" placement="right" onClose={onClose} visible={visible} width="60%">
        <Tabs>
          {deviceStatusByID?.status && (
            <Fragment>
              <TabPane tab="Connection" key="connection">
                <StateConnectionF deviceStatusByID={deviceStatusByID} />
              </TabPane>
              <TabPane tab="SIM" key="sim">
                <StateSIM deviceStatusByID={deviceStatusByID} />
              </TabPane>
              <TabPane tab="GPS" key="gps">
                <StateGPSF deviceStatusByID={deviceStatusByID} />
              </TabPane>
              <TabPane tab="DNS" key="dns">
                <StatesDNSF deviceStatusByID={deviceStatusByID} />
              </TabPane>
            </Fragment>
          )}
          {deviceIdentityByID && (
            <TabPane tab="Identity" key="identity">
              <IdentityTableF deviceStatusByID={deviceStatusByID} deviceIdentityByID={deviceIdentityByID} />
            </TabPane>
          )}
        </Tabs>
      </Drawer>
    </>
  );
};

export default DeviceStatusIdentiy;
